module.exports = __webpack_public_path__ + "static/8th-wall-footer-logo-59bbc461452d4c09572dc570cdec87b6.png";